module.exports = __webpack_public_path__ + "media/images/icons/country_flags/gb-sct-5edc6d75a73111158da1213a861644d8.svg";